import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff, Loader2 } from 'lucide-react';

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141617] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8 animate-fade">
          <img
            src="https://www.riding-watt.com/wp-content/uploads/2024/01/logo-ridingwatt-v2.png"
            alt="Riding Watt"
            className="h-16 mx-auto mb-6"
          />
          <h1 className="text-2xl font-bold text-white font-['Outfit']">
            CRM Riding Watt
          </h1>
          <p className="text-[#8C8F94] mt-2">
            Connectez-vous à votre espace
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-[#1D2327] rounded-xl border border-[#2C3338] p-6 animate-slide-in">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div 
                className="bg-[#2A1515] border border-[#E74C3C]/20 text-[#E74C3C] px-4 py-3 rounded-lg text-sm"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <div>
              <label 
                htmlFor="email" 
                className="block text-sm font-medium text-[#8C8F94] mb-2"
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#141617] border border-[#2C3338] rounded-lg px-4 py-3 text-white placeholder-[#52555A] focus:outline-none focus:border-[#00E01A] focus:ring-1 focus:ring-[#00E01A] transition-colors"
                placeholder="votre@email.com"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label 
                htmlFor="password" 
                className="block text-sm font-medium text-[#8C8F94] mb-2"
              >
                Mot de passe
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#141617] border border-[#2C3338] rounded-lg px-4 py-3 text-white placeholder-[#52555A] focus:outline-none focus:border-[#00E01A] focus:ring-1 focus:ring-[#00E01A] transition-colors pr-12"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8C8F94] hover:text-white transition-colors"
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#00E01A] hover:bg-[#00B815] text-black font-semibold py-3 px-4 rounded-full transition-all duration-200 shadow-[0_0_20px_rgba(0,224,26,0.3)] hover:shadow-[0_0_30px_rgba(0,224,26,0.4)] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              data-testid="login-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 size={20} className="animate-spin" />
                  Connexion...
                </>
              ) : (
                'Se connecter'
              )}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-[#2C3338] text-center">
            <p className="text-sm text-[#8C8F94]">
              Première connexion ? Contactez votre administrateur.
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-[#52555A] text-sm mt-8">
          © 2026 Riding Watt - Tous droits réservés
        </p>
      </div>
    </div>
  );
};

export default Login;
